
const VrstaRada = function(DS) {
    return DS.defineResource({
        name: 'VrstaRada',
        endpoint: '/vrsteRadova'
    });
};

VrstaRada.$inject = ['DS'];


export {VrstaRada};



// WEBPACK FOOTER //
// ./app/models/vrstaRada.js